import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ "source" ]

  toggleMenu(event) {
    this.element.querySelector('#context-menu').classList.toggle('hidden')
  }
}